import * as React from 'react';
import * as marked from 'marked';

export interface MarkdownRendererProps {
  markdown: string;
  Element?: string;
  className?: string;
}
export default ({ markdown, Element = 'div', className = '' }: MarkdownRendererProps) => {
  return (
    <span dangerouslySetInnerHTML={{ __html: marked(markdown) }} className={className} />
  );
};




// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/MarkdownRenderer.tsx